export default "__VITE_ASSET__D8MaVYdz__"